export default function () {
  throw new Error(
    "'NavigationNativeContainer' has been renamed to 'NavigationContainer"
  );
}
